require('./reimburseInvestmentDetailsWithCosts.scss');
// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');
// @ helpers
const { FormattedText, formatText } = require("core/i18n").i18n;
const { formatCurrency, formatWithoutRound } = require('utilities/currencyHelper');
const DateHelper = require('utilities/dateHelper');
const { formatAmount } = require('utilities/currencyHelper');
// @ components
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const BrokerExAntSection = require("components/commons/brokerExAntSection/brokerExAntSection");
const BrokerDataItem = require("components/commons/brokerDataItem/brokerDataItem");
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ constants
const {
    API_ENTERPRISE_NUMBER,
    API_CENTER
} = require('constants/index');
const {
    DATE_FORMAT_ES,
    FIRST_STEP,
    BROKER_REIMBURSE_FUND_TOTAL,
} = require('constants/index');

class ReimburseInvestmentDetailsWithCosts extends React.Component {
    buildTooltip(title, content, target) {
        return (
            <OKTooltip
                title={title}
                content={content}
                placement="top"
                type="explicative"
                target={target}
                offset={[0, -10]}
            />
        );
    }

    buildRightPart() {
        const { immReimburseInvestment } = this.props;
        const exAnteCostList = immReimburseInvestment.get("exAnteCostList");
        return exAnteCostList.map((item, index) => (
            <BrokerExAntSection
                context="reimburseInvestmentDetailsWithCosts"
                eventCategory="orden venta fondos/paso 2"
                section={item}
                key={index}
                complexTooltip={true}
            />
        ));
    }

    render() {
        const { immReimburseInvestment, immFund } = this.props;
        if (immReimburseInvestment.get('exAnteCostListFetching')) {
            return <LoadingSection/>;
        }
        const context = 'reimburseInvestmentDetailsWithCosts';
        const reimburseFund = immReimburseInvestment.getIn([
            'steps',
            FIRST_STEP,
            'reimburseFund',
        ]);
        const isTotal =
        immReimburseInvestment.getIn(['steps', FIRST_STEP, 'type']) ===
        BROKER_REIMBURSE_FUND_TOTAL;
        const immAccount = reimburseFund.get('account');
        const accountBalance = immAccount.get('balance');
        const balanceValue = formatWithoutRound(
            accountBalance.get('amount'),
            2
        );
        const balanceCurrency = formatCurrency(accountBalance.get("currency"));
        const balanceFormatted = `${balanceValue} ${balanceCurrency}`;
        const accountContractNumber = immAccount.get("contractNumber");
        const accountProductNumber = immAccount.get("product");
        const accountCodbban = immAccount.getIn(["ibanComplex", "codbban"]);
        const accountControlDigit = accountCodbban.substring(8, 10);
        const fullAccountNumber = `${API_ENTERPRISE_NUMBER}${API_CENTER}${accountControlDigit}${accountProductNumber}${accountContractNumber}`;
        const accountHolder = immAccount.get("accountHolder");
        const accountAlias = immAccount.getIn(["alias"]);
        const fundContractNumber = reimburseFund.get("contractNumber");
        const fundProductNumber = reimburseFund.get("productNumber");
        let fundValue;
        if(isTotal) {
            const fundCurrency = immFund.get('totalValueCurrency');
            if (
                accountBalance.get("currency") === "EUR" &&
                fundCurrency !== "EUR" &&
                !!immFund.get("totalValueEur")
            ) {
                fundValue = formatWithoutRound(
                    immFund.getIn(["totalValueEur", "amount"]),
                    2
                );
            } else {
                fundValue = formatWithoutRound(immFund.get("totalValue"), 2);
            }
        }else{
            const partialAmount = immReimburseInvestment.getIn([
                'steps',
                FIRST_STEP,
                'amount'
            ]);
            fundValue = formatWithoutRound(partialAmount, 2);
        }
        const baseImport = `${fundValue} ${balanceCurrency}`
        const fundControlDigit = reimburseFund.get("fundControlDigit");
        const fullFundContractNumber = `${API_ENTERPRISE_NUMBER}${API_CENTER}${fundControlDigit}${fundProductNumber}${fundContractNumber}`;
        const fundName = immReimburseInvestment.getIn([
            "steps",
            FIRST_STEP,
            "reimburseInvestment",
            "name",
        ]);
        const participations = isTotal
            ? formatAmount(reimburseFund.get("fundParticipations"), null, 5)
            : null;
        const participationsItem = isTotal ? (
            <BrokerDataItem
                label={`${context}-participations`}
                data={participations}
            />
        ) : null;
        const labelDate = DateHelper.buildFormattedDate(
            moment(),
            DATE_FORMAT_ES
        );
        const sellType = isTotal ? (
            <FormattedText value={`${context}-total`} />
        ) : (
            <FormattedText value={`${context}-partial`} />
        );
        const accountValue = (
            <FormattedText
                value={`${context}-accountValues`}
                injectedStrings={[
                    accountAlias.toUpperCase(),
                    fullAccountNumber.toUpperCase(),
                    balanceFormatted,
                ]}
            />
        );
        return (
            <div className="reimburse-investment-details-with-costs container-fluid">
                <div className="row">
                    <div className="col-xs-6 reimburse-investment-details-with-costs__content-left">
                        <div className="reimburse-investment-details-with-costs__left-items-container">
                            <div className="reimburse-investment-details-with-costs__content-title">
                                <FormattedText
                                    value={`${context}-orderDataTitle`}
                                />
                            </div>
                            <BrokerDataItem
                                label={`${context}-investmentFund`}
                                data={fundName}
                            />
                            <BrokerDataItem
                                label={`${context}-baseImport`}
                                data={baseImport}
                                tooltipTitleKey={`${context}-baseImportTooltipTitle`}
                                tooltipContentKey={`${context}-baseImportComplexTooltip`}
                                eventCategory="orden venta fondos/paso 2"
                                eventTag={formatText(
                                    "reimburseInvestmentDetailsWithCosts-orderData_estimatedAmount_eventTag"
                                )}
                                complexTooltip
                            />
                            {participationsItem}
                            <BrokerDataItem
                                label={`${context}-type`}
                                data={sellType}
                            />
                            <BrokerDataItem
                                label={`${context}-date`}
                                data={labelDate}
                            />
                            <BrokerDataItem
                                label={`${context}-contractNumber`}
                                data={fullFundContractNumber}
                            />
                            <BrokerDataItem
                                label={`${context}-holder`}
                                data={accountHolder}
                            />
                            <BrokerDataItem
                                label={`${context}-account`}
                                data={accountValue}
                            />
                        </div>
                    </div>
                    <div className="col-xs-6 reimburse-investment-details-with-costs__content-right container-fluid">
                        {this.buildRightPart()}
                    </div>
                </div>
            </div>
        );
    }
}
ReimburseInvestmentDetailsWithCosts.propTypes = {
    immReimburseInvestment: PropTypes.object.isRequired,
    immFund: PropTypes.object.isRequired,
    isSuccess: PropTypes.bool,
};
module.exports = ReimburseInvestmentDetailsWithCosts;
